import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_3168fb60 from 'nuxt_plugin_plugin_3168fb60' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_28b8c1ac from 'nuxt_plugin_sentryserver_28b8c1ac' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_f42ba4bc from 'nuxt_plugin_sentryclient_f42ba4bc' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_nuxtplugine7f211b8_4ec30be4 from 'nuxt_plugin_nuxtplugine7f211b8_4ec30be4' // Source: ./nuxt.plugin.e7f211b8.js (mode: 'client')
import nuxt_plugin_nuxtplugin05378361_0dbc7043 from 'nuxt_plugin_nuxtplugin05378361_0dbc7043' // Source: ./nuxt.plugin.05378361.js (mode: 'all')
import nuxt_plugin_nuxtdirective13b45c10_07b9bc5e from 'nuxt_plugin_nuxtdirective13b45c10_07b9bc5e' // Source: ./nuxt.directive.13b45c10.js (mode: 'client')
import nuxt_plugin_nuxtsettingsc68f25a8_5ae33037 from 'nuxt_plugin_nuxtsettingsc68f25a8_5ae33037' // Source: ./nuxt.settings.c68f25a8.js (mode: 'all')
import nuxt_plugin_workbox_401f5902 from 'nuxt_plugin_workbox_401f5902' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_65987e15 from 'nuxt_plugin_metaplugin_65987e15' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_6a402389 from 'nuxt_plugin_iconplugin_6a402389' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_objectFitPolyfill_042ed51e from 'nuxt_plugin_objectFitPolyfill_042ed51e' // Source: ./nuxt-polyfill/objectFitPolyfill.js (mode: 'all')
import nuxt_plugin_gtm_390ce488 from 'nuxt_plugin_gtm_390ce488' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_nuxtplugin7b928df8_4d400640 from 'nuxt_plugin_nuxtplugin7b928df8_4d400640' // Source: ./nuxt.plugin.7b928df8.js (mode: 'client')
import nuxt_plugin_pluginscraftfb022860_74419350 from 'nuxt_plugin_pluginscraftfb022860_74419350' // Source: ./plugins.craft.fb022860.js (mode: 'all')
import nuxt_plugin_nuxtspastoreinitplugin5f1d5f06_e0e7cd76 from 'nuxt_plugin_nuxtspastoreinitplugin5f1d5f06_e0e7cd76' // Source: ./nuxt-spa-store-init.plugin.5f1d5f06.js (mode: 'all')
import nuxt_plugin_axios_4c62a566 from 'nuxt_plugin_axios_4c62a566' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_fontLoader_499454f0 from 'nuxt_plugin_fontLoader_499454f0' // Source: ./fontLoader.js (mode: 'client')
import nuxt_plugin_helpers_01318928 from 'nuxt_plugin_helpers_01318928' // Source: ../../../../node_modules/@bkwld/cloak/plugins/helpers (mode: 'all')
import nuxt_plugin_focusvisible_64b19c24 from 'nuxt_plugin_focusvisible_64b19c24' // Source: ../../../../node_modules/@bkwld/cloak/plugins/focus-visible (mode: 'all')
import nuxt_plugin_components_cc74d94a from 'nuxt_plugin_components_cc74d94a' // Source: ../../../plugins/components (mode: 'all')
import nuxt_plugin_services_bc71243a from 'nuxt_plugin_services_bc71243a' // Source: ../../../plugins/services (mode: 'all')
import nuxt_plugin_clientglobals_47b5b2f3 from 'nuxt_plugin_clientglobals_47b5b2f3' // Source: ../../../plugins/client-globals (mode: 'client')
import nuxt_plugin_hydratecart_53824adf from 'nuxt_plugin_hydratecart_53824adf' // Source: ../../../plugins/hydrate-cart (mode: 'client')
import nuxt_plugin_hydratecustomer_0579581d from 'nuxt_plugin_hydratecustomer_0579581d' // Source: ../../../plugins/hydrate-customer (mode: 'client')
import nuxt_plugin_recharge_1f84dc2c from 'nuxt_plugin_recharge_1f84dc2c' // Source: ../../../plugins/recharge (mode: 'client')
import nuxt_plugin_privacy_10da8163 from 'nuxt_plugin_privacy_10da8163' // Source: ../../../plugins/privacy (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"msapplication-tap-highlight","content":"no"},{"name":"facebook-domain-verification","content":"u0ij6rspe06fy60ckumabnhx1wzjpl"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"}],"script":[{"hid":"polyfill","src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fpolyfill\u002Fv3\u002Fpolyfill.min.js?features=HTMLInputElement.prototype.valueAsDate","body":true},{"src":"https:\u002F\u002Fcdn.shopify.com\u002Fshopifycloud\u002Fconsent-tracking-api\u002Fv0.1\u002Fconsent-tracking-api.js","async":true,"defer":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-KJBS8SH')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"titleTemplate":function(title) {
          if (title && title !== process.env.SITE_NAME) {
            return `${title} | ${process.env.SITE_NAME}`;
          } else {
            return process.env.SITE_NAME;
          }
        },"link":[{"hid":"font-preload","rel":"preload","as":"style","href":"https:\u002F\u002Fuse.typekit.net\u002Fgus4jzq.css"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-KJBS8SH&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"},{"hid":"font-noscript","innerHTML":"\u003Clink rel=\"stylesheet\" href=\"https:\u002F\u002Fuse.typekit.net\u002Fgus4jzq.css\"\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"],"font-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_3168fb60 === 'function') {
    await nuxt_plugin_plugin_3168fb60(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_28b8c1ac === 'function') {
    await nuxt_plugin_sentryserver_28b8c1ac(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_f42ba4bc === 'function') {
    await nuxt_plugin_sentryclient_f42ba4bc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtplugine7f211b8_4ec30be4 === 'function') {
    await nuxt_plugin_nuxtplugine7f211b8_4ec30be4(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtplugin05378361_0dbc7043 === 'function') {
    await nuxt_plugin_nuxtplugin05378361_0dbc7043(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtdirective13b45c10_07b9bc5e === 'function') {
    await nuxt_plugin_nuxtdirective13b45c10_07b9bc5e(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsettingsc68f25a8_5ae33037 === 'function') {
    await nuxt_plugin_nuxtsettingsc68f25a8_5ae33037(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_401f5902 === 'function') {
    await nuxt_plugin_workbox_401f5902(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_65987e15 === 'function') {
    await nuxt_plugin_metaplugin_65987e15(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_6a402389 === 'function') {
    await nuxt_plugin_iconplugin_6a402389(app.context, inject)
  }

  if (typeof nuxt_plugin_objectFitPolyfill_042ed51e === 'function') {
    await nuxt_plugin_objectFitPolyfill_042ed51e(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_390ce488 === 'function') {
    await nuxt_plugin_gtm_390ce488(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtplugin7b928df8_4d400640 === 'function') {
    await nuxt_plugin_nuxtplugin7b928df8_4d400640(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginscraftfb022860_74419350 === 'function') {
    await nuxt_plugin_pluginscraftfb022860_74419350(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtspastoreinitplugin5f1d5f06_e0e7cd76 === 'function') {
    await nuxt_plugin_nuxtspastoreinitplugin5f1d5f06_e0e7cd76(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_4c62a566 === 'function') {
    await nuxt_plugin_axios_4c62a566(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fontLoader_499454f0 === 'function') {
    await nuxt_plugin_fontLoader_499454f0(app.context, inject)
  }

  if (typeof nuxt_plugin_helpers_01318928 === 'function') {
    await nuxt_plugin_helpers_01318928(app.context, inject)
  }

  if (typeof nuxt_plugin_focusvisible_64b19c24 === 'function') {
    await nuxt_plugin_focusvisible_64b19c24(app.context, inject)
  }

  if (typeof nuxt_plugin_components_cc74d94a === 'function') {
    await nuxt_plugin_components_cc74d94a(app.context, inject)
  }

  if (typeof nuxt_plugin_services_bc71243a === 'function') {
    await nuxt_plugin_services_bc71243a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clientglobals_47b5b2f3 === 'function') {
    await nuxt_plugin_clientglobals_47b5b2f3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hydratecart_53824adf === 'function') {
    await nuxt_plugin_hydratecart_53824adf(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hydratecustomer_0579581d === 'function') {
    await nuxt_plugin_hydratecustomer_0579581d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_recharge_1f84dc2c === 'function') {
    await nuxt_plugin_recharge_1f84dc2c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_privacy_10da8163 === 'function') {
    await nuxt_plugin_privacy_10da8163(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
